import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import logo from '../Image/logo.png'

function PaymentStatus() {
  const { search } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(search)
    const txnId = params.get('transactionId') || params.get('txnid') || localStorage.getItem('lastTxnId') || ''
    const merchantId = params.get('merchantId') || localStorage.getItem('lastMerchantId') || 'PGTESTPAYUAT86'
    const amount = params.get('amount') || localStorage.getItem('lastAmount') || ''

    if (txnId) {
      axios.get(`https://api.ndtechland.com/api/PaymentGatway/CheckStatus/${txnId}?merchantId=${merchantId}`)
        .then(response => {
          const statusData = response.data
          const isSuccess = statusData.success && (statusData.code === "PAYMENT_SUCCESS" || statusData.data?.code === "PAYMENT_SUCCESS")
          const msg = statusData.message || statusData.data?.message || ''

          if (isSuccess) {
            // Clear localStorage on success
            localStorage.removeItem('lastTxnId')
            localStorage.removeItem('lastAmount')
            localStorage.removeItem('lastMerchantId')
            navigate(`/payment-success?txnid=${txnId}&amount=${amount}&message=${encodeURIComponent(msg)}&statuscode=PAYMENT_SUCCESS`, { replace: true })
          } else {
            navigate(`/payment-failed?txnid=${txnId}&amount=${amount}&message=${encodeURIComponent(msg)}&statuscode=${statusData.code || 'PAYMENT_FAILED'}`, { replace: true })
          }
        })
        .catch(err => {
          console.error('CheckStatus verification error:', err)
          setErrorMsg('Verification error occurred. Redirecting to status details...')
          setTimeout(() => {
            navigate(`/payment-failed?txnid=${txnId}&amount=${amount}&message=${encodeURIComponent('Verification error occurred. Please contact support.')}&statuscode=ERROR`, { replace: true })
          }, 2000)
        })
    } else {
      setErrorMsg('No active transaction details found. Redirecting...')
      setTimeout(() => {
        navigate('/payment-failed?message=No+transaction+details+found+to+verify', { replace: true })
      }, 2000)
    }
  }, [navigate, search])

  if (loading) {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
          
          .ps-loading-page {
            min-height: 100vh;
            background: #f5f6fa;
            font-family: 'Inter', sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 24px;
            box-sizing: border-box;
          }

          .ps-card {
            width: 100%;
            max-width: 420px;
            background: #ffffff;
            border-radius: 16px;
            border: 1px solid #e2e8f0;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02);
            padding: 40px 24px;
            text-align: center;
            box-sizing: border-box;
          }

          .ps-logo {
            width: 60px;
            height: 60px;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            background: #fff;
            padding: 4px;
            margin: 0 auto 24px;
          }

          .ps-logo img {
            width: 100%;
            object-fit: contain;
          }

          .ps-spinner {
            width: 44px;
            height: 44px;
            border: 3.5px solid #f3f4f6;
            border-top: 3.5px solid #5b21b6;
            border-radius: 50%;
            margin: 0 auto 20px;
            animation: ps-spin 1s linear infinite;
          }

          @keyframes ps-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .ps-title {
            font-size: 16px;
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 6px;
          }

          .ps-subtitle {
            font-size: 13px;
            color: #64748b;
          }

          .ps-error {
            font-size: 13px;
            color: #ef4444;
            margin-top: 8px;
          }
        `}</style>
        <div className="ps-loading-page">
          <div className="ps-card">
            <div className="ps-logo">
              <img src={logo} alt="ND Techland" />
            </div>
            <div className="ps-spinner"></div>
            <div className="ps-title">Verifying Payment Status</div>
            <div className="ps-subtitle">Please do not refresh or close this page.</div>
            {errorMsg && <div className="ps-error">{errorMsg}</div>}
          </div>
        </div>
      </>
    )
  }

  return null
}

export default PaymentStatus
